import { saveAs } from "file-saver";

const About = ({ darkMode }) => {
  const handleDownloadCV = () => {
    // Replace with the actual path to your CV file
    const cvPath = "./Manuhe_wolde.pdf";
    saveAs(cvPath, "Manuhe_Wolde_CV.pdf");
  };

  return (
    <section id="about" className="py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-12 text-center">
          <span className={darkMode ? "text-blue-400" : "text-blue-600"}>
            About
          </span>{" "}
          Me
        </h2>

        <div className="flex flex-col md:flex-row gap-12">
          <div className="md:w-1/2">
            <div
              className={`rounded-lg overflow-hidden ${
                darkMode ? "bg-gray-800" : "bg-white shadow-lg"
              }`}
            >
              <div
                className={`h-96 ${
                  darkMode ? "bg-gray-700" : "bg-gray-200"
                } flex items-center justify-center`}
              >
                <img
                  src="/images/manu23.jpg"
                  alt="Manuhe Wolde - Fullstack Developer"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="md:w-1/2">
            <h3 className="text-2xl font-semibold mb-4">
              Fullstack Developer | Software Engineer
            </h3>
            <div
              className={`mb-6 ${
                darkMode ? "text-gray-300" : "text-gray-600"
              } space-y-4`}
            >
              <p>
                I am a Full-Stack Developer with expertise in building web
                applications using modern technologies, including the MERN stack
                (MongoDB, Express.js, React, Node.js)  and Next.js. I have a strong passion for learning new technologies
                and solving real-life problems through innovative solutions.
              </p>

              <p>
                With a commitment to best practices in software development, I
                focus on creating seamless user experiences and efficient
                server-side applications. I thrive in collaborative
                environments, working with cross-functional teams to deliver
                high-quality projects on time.
              </p>
            </div>

            <div
              className={`p-6 rounded-lg ${
                darkMode ? "bg-gray-800" : "bg-blue-50"
              } flex flex-col sm:flex-row items-center justify-between gap-4`}
            >
              <div className="text-center sm:text-left">
                <p className="text-3xl font-bold">3+</p>
                <p className={darkMode ? "text-gray-300" : "text-gray-600"}>
                  Projects completed
                </p>
              </div>
              <button
                onClick={handleDownloadCV}
                className={`px-6 py-3 rounded-lg font-medium ${
                  darkMode
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white transition-colors whitespace-nowrap`}
                aria-label="Download CV"
              >
                DOWNLOAD CV
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
